import React from 'react';
import { Checkbox } from 'primereact/checkbox';

/**
 * Checkbox v dialógu „Nastaviť masku“ — ID je povinný systémový stĺpec (native disabled checked),
 * ostatné stĺpce používajú PrimeReact Checkbox.
 */
export function MaintenanceMaskDialogCheckbox({ field, inputId, title, columnsVisible, onChange }) {
  const fieldKey = field == null ? '' : String(field);

  if (fieldKey === 'id') {
    return (
      <input
        id={inputId}
        type="checkbox"
        checked
        disabled
        readOnly
        aria-label={title ?? 'ID'}
        className="mt-0.5 h-[22px] w-[22px] shrink-0 cursor-not-allowed accent-blue-700"
        onChange={() => {}}
      />
    );
  }

  return (
    <Checkbox
      inputId={inputId}
      checked={columnsVisible[fieldKey] !== false}
      onChange={(e) => onChange(fieldKey, e.checked)}
    />
  );
}
